import { render, staticRenderFns } from "./TabsSearch.vue?vue&type=template&id=d8b52882&scoped=true&"
import script from "./TabsSearch.vue?vue&type=script&lang=js&"
export * from "./TabsSearch.vue?vue&type=script&lang=js&"
import style0 from "./TabsSearch.vue?vue&type=style&index=0&id=d8b52882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b52882",
  null
  
)

export default component.exports